import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.25 0C.56 0 0 .56 0 1.25v3.333c0 .69.56 1.25 1.25 1.25h3.333c.69 0 1.25-.56 1.25-1.25V1.25c0-.69-.56-1.25-1.25-1.25zm.417 4.167v-2.5h2.5v2.5zM8.75 0C8.06 0 7.5.56 7.5 1.25v3.333c0 .69.56 1.25 1.25 1.25h3.333c.69 0 1.25-.56 1.25-1.25V1.25c0-.69-.56-1.25-1.25-1.25zm.417 4.167v-2.5h2.5v2.5zM7.5 8.75c0-.69.56-1.25 1.25-1.25h3.333c.69 0 1.25.56 1.25 1.25v3.333c0 .69-.56 1.25-1.25 1.25H8.75c-.69 0-1.25-.56-1.25-1.25zm1.667.417v2.5h2.5v-2.5zM1.25 7.5C.56 7.5 0 8.06 0 8.75v3.333c0 .69.56 1.25 1.25 1.25h3.333c.69 0 1.25-.56 1.25-1.25V8.75c0-.69-.56-1.25-1.25-1.25zm.417 4.167v-2.5h2.5v2.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }